import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoChevronForward } from "react-icons/io5";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function SettingSidebar() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(location.pathname); // default to current URL path
  const navigate = useNavigate();
  const toggleDropdown = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  const handleSelect = (path) => {
    setSelectedMenu(path);
  };

  const logout = () => {
    Cookies.remove("user_id");
    Cookies.remove("username");
    Cookies.remove("token");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    window.location.reload(); // Force refresh after navigation
    toast.success("LogOut Successfully!!");
  };
  const [sidebarActive, setSidebarActive] = useState(false);
  return (
    <>
      <div
        className="col-12 settingbar-menu"
        onClick={() => setSidebarActive(!sidebarActive)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          fill="currentColor"
          class="bi bi-sliders"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
          />
        </svg>
      </div>
      <div
        className={`col-3 col-sm-3 col-md-3  col-xl-3 col-lg-3 setting-sidebar ${
          sidebarActive ? "setting-sidebar-active" : ""
        }`}
      >
        <div
          className="setting-detail"
          style={{ position: "sticky", top: "35px" }}
        >
          <div className="title">
            <h1>
              <b>My Accounts</b>
            </h1>
            <button
              className="setting_sidebar_close_btn"
              onClick={() => setSidebarActive(!sidebarActive)}
            >
              {" "}
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          <div className="setting-list">
            <ul>
              <li className={selectedMenu === "/setting" ? "active" : ""}>
                <Link to="/setting" onClick={() => handleSelect("/setting")}>
                  <p>Account Details</p>
                </Link>
              </li>
              <li className={selectedMenu === "/notification" ? "active" : ""}>
                <Link
                  to="/notification"
                  onClick={() => handleSelect("/notification")}
                >
                  <p>Notification</p>
                </Link>
              </li>
              <li className={selectedMenu === "/wishlist" ? "active" : ""}>
                <Link to="/wishlist" onClick={() => handleSelect("/wishlist")}>
                  <p>Watchlist</p>
                </Link>
              </li>

              {/* Buying Dropdown */}
              <li
                onClick={() => toggleDropdown("buying")}
                className={`dropdown-item ${
                  openMenu === "buying" ? "open" : ""
                }`}
              >
                <Link to="#">
                  <p>Buying</p>
                  <IoChevronForward className="setting-icon" />
                </Link>
                <ul
                  className={`setting-drop-down ${
                    openMenu === "buying" ? "open" : ""
                  }`}
                >
                  <li className={selectedMenu === "/mybids" ? "active" : ""}>
                    <Link to="/mybids" onClick={() => handleSelect("/mybids")}>
                      My Bids
                    </Link>
                  </li>
                  <li className={selectedMenu === "/won" ? "active" : ""}>
                    <Link to="/won" onClick={() => handleSelect("/won")}>
                      Won
                    </Link>
                  </li>
                  <li className={selectedMenu === "/lost" ? "active" : ""}>
                    <Link to="/lost" onClick={() => handleSelect("/lost")}>
                      Lost
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Selling Dropdown */}
              <li
                onClick={() => toggleDropdown("selling")}
                className={`dropdown-item ${
                  openMenu === "selling" ? "open" : ""
                }`}
              >
                <Link to="#">
                  <p>Selling</p>
                  <IoChevronForward className="setting-icon" />
                </Link>
                <ul
                  className={`setting-drop-down ${
                    openMenu === "selling" ? "open" : ""
                  }`}
                >
                  <li className={selectedMenu === "/mybids" ? "active" : ""}>
                    <Link
                      to="/myselling"
                      onClick={() => handleSelect("/myselling")}
                    >
                      Items I'm Selling
                    </Link>
                  </li>
                  <li className={selectedMenu === "/sold" ? "active" : ""}>
                    <Link to="/sold" onClick={() => handleSelect("/sold")}>
                      Sold
                    </Link>
                  </li>
                  <li className={selectedMenu === "/unsold" ? "active" : ""}>
                    <Link to="/unsold" onClick={() => handleSelect("/unsold")}>
                      Unsold
                    </Link>
                  </li>
                  <li className={selectedMenu === "/drafts" ? "active" : ""}>
                    <Link to="/drafts" onClick={() => handleSelect("/drafts")}>
                      Drafts
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={selectedMenu === "/question" ? "active" : ""}>
                <Link to="/question" onClick={() => handleSelect("/question")}>
                  <p>Q & A</p>
                </Link>
              </li>
              <li className={selectedMenu === "/charges" ? "active" : ""}>
                <Link to="/charges" onClick={() => handleSelect("/charges")}>
                  <p>Charges Hisory</p>
                </Link>
              </li>
              <li className={selectedMenu === "/Subscription" ? "active" : ""}>
                <Link
                  to="/Subscription"
                  onClick={() => handleSelect("/Subscription")}
                >
                  <p>My Membership</p>
                </Link>
              </li>
              <li className={selectedMenu === "/log-out" ? "active" : ""}>
                <Link to="/#" onClick={logout}>
                  <p>Log Out</p>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
